<div id="openExtendsVoucherCancelled" class="modal fade in" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Comunicación de Baja</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="close()">&times;</button>
      </div>
      <app-loading-modal></app-loading-modal>
      <form validate [formGroup]="item" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="form-group col-lg-12">
                 <p class="f-s-10 m-b-0">El Comprobante que han sido seleccionado sera dado de "Baja", por favor ingrese el motivo de esta acción:</p>
                </div>
                <div class="form-group col-lg-12">
                  <label>Motivo anulación<span class="required"></span></label>
                  <textarea id="motive_cancelled" rows="3"
                    [ngClass]="{'parsley-error': (submitted && f['motive_cancelled'].errors)}" formControlName="motive_cancelled"
                    required="true" class="form-control no-resize"></textarea>
                  <div *ngIf="submitted && f['motive_cancelled'].errors">
                    <small class="text-danger" *ngIf="f['motive_cancelled'].errors['required']">Campo es requerido</small>
                    <small class="text-danger" *ngIf="f['motive_cancelled'].errors['minlength']">Campo Muy corto</small>
                    <small class="text-danger" *ngIf="f['motive_cancelled'].errors['maxlength']">Campo Muy largo</small>
                  </div>
                </div>
                <div class="col-lg-12">
                  <small class="text-danger">El llenado del campo es requerido.</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary close-btn" data-dismiss="modal" (click)="close()">Cancelar</button>
          <button type="submit" class="btn btn-danger">CONFIRMAR BAJA</button>
        </div>
      </form>
    </div>
  </div>
</div>
